import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { Button, Collapse, Nav, Navbar, NavbarToggler, Row } from "reactstrap";
import { ITenant } from "../../app/models/tenant";
import { IUser } from "../../app/models/user";
import { RootStoreContext } from "../../app/stores/rootStore";
import LeaveMeetingButton from "../buttons/LeaveMeetingButton";
import SyncButton from "../buttons/SyncButton";
import MainNavBarConnectionStatus from "./MainNavBarConnectionStatus";
import MainNavBarDropdown from "./MainNavBarDropdown";
import MainNavBarTitle from "./MainNavBarTitle";
import "../../assets/scss/broadcastController/broadcastController.scss";
import BroadcastStreamingContainer from "../broadcast_Openvidu/BroadcastStreamingContainer";
import { UserTypes } from "../../app/models/broadcast";
import CaboloRecordingButton from "../buttons/CaboloRecordingButton";

interface IParams {
  currentTenant: ITenant;
  allTenants: ITenant[];
  user: IUser;
  goBack: () => void;
  currentUrl?: string;
}

const MainNavBar: React.FC<IParams> = ({
  currentTenant,
  allTenants,
  user,
  goBack,
  currentUrl
}) => {
  const rootStore = useContext(RootStoreContext);
  const { attendingMeeting, isSharing ,isSynced } = rootStore.playerStore;
  const { toggleIsBroadcastControllerOpen, broadcastLauncherTypes, subscribers, publisher, broadcastUser } = rootStore.broadcastStore;
  const { theme } = rootStore.commonStore;
  const{canViewODG} = rootStore.tenantStore;
  const { isMobileMediaQuery, setIsSidebarModalOpen, isSidebarModalOpen } = rootStore.responsiveStore;
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
 
  //// COMMENTED FOR FIXED SIDEBAR
  // const handleSidebarClick = () => {
  //   if (sidebarOpen) {
  //     document.body.classList.remove("NavbarShift");
  //   } else {
  //     document.body.classList.add("NavbarShift");
  //   }
  //   changeSidebar();
  // };

  const checkDisabledButton = () => {
    if (
      isSharing ||
      !attendingMeeting ||
      (attendingMeeting &&
        (!attendingMeeting.sharingUserId ||
          attendingMeeting.sharingUserId === user?.id))
    )
      return true;
    else return false;
  };
  return (
    <>
      <Navbar
        className={classNames("p-0", theme!.headerColor)}
        expand={true}
        style={{ height: "40px" }}
      >
        {/* {!sidebarOpen ? (
          <Button
            color="inherit"
            aria-label="open drawer"
            onClick={handleSidebarClick}
            className={classnames(`text-${theme!.sidebarBurgherButton}`,"text-center burgherButton",`border-bottom-${theme?.sidebarBorder}`, )}
          >
            <i
              className={classNames("fas fa-bars fa-lg")}
            ></i>
          </Button>
        ) : null} */}
        {isMobileMediaQuery && (currentUrl!.includes(`/browse/meetings/`))&& (
          <Button
            className={classNames("backNavbarButton", theme!.headerTextColor)}
            onClick={(e) => {
              e.preventDefault();
              goBack();
            }}
            color="inherit"
          >
            <i className="fas fa-chevron-left"></i>
          </Button>
        )}
        {isMobileMediaQuery && !(currentUrl!.includes(`/browse/meetings/`)) &&(
                    <Button
                    className={classNames("backNavbarButton", theme!.headerTextColor)}
                    onClick={(e) => {
                      setIsSidebarModalOpen(!isSidebarModalOpen)
                    }}
                    color="inherit"
                  >
                    <i className="fas fa-bars"></i>
                  </Button>
        )}
        <div
        style={{paddingLeft:"1px", marginLeft:"0px", marginRight:"0px"}}
          className={classNames(
            "navbarText text-truncate navbar-brand ",
            isMobileMediaQuery ? "": "ml-2",
           ( isMobileMediaQuery && !checkDisabledButton()) ? "col-4 col-md-4" : "col-5 col-md-8",
          //  ( isMobileMediaQuery && !checkDisabledButton()) ? "col-4 col-md-4" : "col-6 col-md-8",
            theme!.headerTextColor
          )}
        >
          <MainNavBarTitle tenant={currentTenant} />
        </div>
        <NavbarToggler onClick={toggle} />
        {/* <Collapse isOpen={isOpen} navbar style={{marginLeft:"-11%"}} > */}
        <Collapse isOpen={isOpen} navbar  >
          <div className="ml-auto"></div>

        {attendingMeeting &&  attendingMeeting.hasEnabledCabolo &&currentTenant &&(<>
       <CaboloRecordingButton></CaboloRecordingButton>
        
        </>)}

          {attendingMeeting && currentTenant && (
            <>
            {broadcastLauncherTypes && broadcastLauncherTypes !== "undefined" &&(
              <Button 
                className={classNames(publisher ? "blinking" : "",
                  "broadcastMenuButtonHeader",
                  theme!.headerTextColor
                )}
                onClick={() => toggleIsBroadcastControllerOpen()}>
              <i className="fad fa-users"></i>
              </Button>
            )}
              <SyncButton isOpen={isOpen} />
              <LeaveMeetingButton />
            </>
          )}
          <MainNavBarConnectionStatus />
         {/*         
            <Nav navbar >
            <MainNavBarDropdown
              currentTenant={currentTenant}
              allTenants={allTenants}
              user={user}
            />
          </Nav> */}

         {isMobileMediaQuery && !attendingMeeting && (
        <Nav navbar>
          <MainNavBarDropdown
            currentTenant={currentTenant}
            allTenants={allTenants}
            user={user}
          />
        </Nav>
          )}

        {!isMobileMediaQuery && (
          <Nav navbar>
            <MainNavBarDropdown
              currentTenant={currentTenant}
              allTenants={allTenants}
              user={user}
            />
          </Nav>
        )}
        </Collapse>
      </Navbar>
      <Row>
        {subscribers && subscribers.length > 0 && subscribers.map((subscriber, index) => { 
          let subscriberData = JSON.parse(subscriber.stream.connection.data);
          let isGrabber = subscriberData.userType === UserTypes.grabber;
          var mediaStream = subscriber.stream.getMediaStream();
          return(
            <div key={"ContainerAudioDiv_" + index + "_" + subscriber.stream.connection.connectionId}>
              {(broadcastUser.broadcastUserTypeId !== UserTypes.external || (broadcastUser.broadcastUserTypeId === UserTypes.external && (subscriberData.userType === UserTypes.internalOpenvidu || subscriberData.userType === UserTypes.externalOpenvidu))) &&(
                <BroadcastStreamingContainer 
                  user={subscriber}
                  userId={subscriberData.userId.toString()}
                  mediaStream={mediaStream}
                  isGrabber={isGrabber}
                  onlyAudio={true}
                  />
              )}
            </div>
            )
          }
        )}
      </Row>
    </>
  );
};

export default observer(MainNavBar);
